import React, { useRef } from "react";
import { motion, useInView } from "motion/react";
import { staggerContainer, fadeInUp } from "./AnimationVariants";
import { PrimaryActions } from "./PrimaryActions";

export function ClosingCta({
  eyebrow = "Get started",
  title = "Your gym, in one ecosystem.",
  text = "Start today, or book a demo and we'll show you around.",
}: {
  eyebrow?: string;
  title?: string;
  text?: React.ReactNode;
}) {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section
      ref={sectionRef}
      aria-labelledby="closing-title"
      className="w-full pt-14 pb-20 md:pt-16 md:pb-28"
    >
      <motion.div
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={staggerContainer}
        className="mx-auto flex max-w-[1400px] w-[calc(100%-2rem)] md:w-[calc(100%-240px)] flex-col items-center text-center"
      >
        <motion.p
          variants={fadeInUp}
          className="text-xs leading-none uppercase tracking-[0.12em] text-white/55"
        >
          {eyebrow}
        </motion.p>
        <motion.h2
          id="closing-title"
          variants={fadeInUp}
          className="mt-4 text-3xl md:text-4xl font-semibold tracking-tight text-white"
        >
          {title}
        </motion.h2>
        <motion.p
          variants={fadeInUp}
          className="mt-4 max-w-lg text-base text-white/60 text-balance"
        >
          {text}
        </motion.p>

        <PrimaryActions className="mt-8 w-full sm:w-[440px]" secondaryWhenSignedIn />
      </motion.div>
    </section>
  );
}
